<div class="entities-filter">
    <!-- SINGLE SHIPPER -->
    @if (hasSingleShipper) {
    <span kendoTooltip
          [title]="getFilterTooltip(filterCollection.customers[0])">
        <button class="btn btn-outline-primary"
                type="button"
                [class.active]="isSelected(filterCollection.customers[0])"
                [disabled]="
                    isDisabled ||
                    isFilterDisabled(filterCollection.customers[0])
                "
                (click)="onShipperClick(filterCollection.customers[0])">
            {{ filterCollection.customers[0].name }}
        </button>
    </span>
    }

    <!-- MULTIPLE SHIPPERS -->
    @if (hasMultipleShippers) {
    <div class="d-inline-block shipper-selection"
         [class.selected]="isShipperSelected"
         kendoTooltip
         position="top"
         [offset]="20"
         [title]="
                isShipperDropdownDisabled
                    ? TOOLTIP_MAX
                    : 'Shipper specific data.'
            ">
        <kendo-splitbutton [data]="filterCollection.customers"
                           textField="name"
                           [text]="shipperToggleText"
                           [arrowButtonSvgIcon]="collapseDownIcon"
                           [arrowButtonClass]="
                    isShipperSelected
                        ? 'shipper-selected'
                        : 'shipper-unselected'
                "
                           [buttonClass]="
                    isShipperSelected
                        ? 'shipper-selected'
                        : 'shipper-unselected'
                "
                           [disabled]="isDisabled || isShipperDropdownDisabled"
                           (buttonClick)="onShippersClick()"
                           (itemClick)="onShippersItemClick($event)">
            <ng-template kendoSplitButtonItemTemplate let-dataItem>
                <span class="splitbutton-item"
                      [class.selected]="isSelected(dataItem)">
                    {{ dataItem.name }}
                </span>
            </ng-template>
        </kendo-splitbutton>
    </div>
    }

    <!-- SINGLE ASSOCIATION -->
    @if (hasSingleAssociation) {
    <span kendoTooltip
          [title]="getFilterTooltip(filterCollection.associations[0])">
        <button class="btn btn-outline-primary"
                type="button"
                [class.active]="isSelected(filterCollection.associations[0])"
                [disabled]="
                    isDisabled ||
                    isFilterDisabled(filterCollection.associations[0])
                "
                (click)="onAssociationClick(filterCollection.associations[0])">
            {{ associationToggleText }}
        </button>
    </span>
    }

    <!-- MULTIPLE ASSOCIATIONS -->
    @if (hasMultipleAssociations) {
    <div class="d-inline-block association-selection"
         [class.selected]="isAssociationSelected"
         kendoTooltip
         position="top"
         [offset]="20"
         [title]="
                isAssociationDropdownDisabled
                    ? TOOLTIP_MAX
                    : 'Association specific data.'
            ">
        <kendo-splitbutton [data]="filterCollection.associations"
                           textField="name"
                           [text]="associationToggleText"
                           [arrowButtonSvgIcon]="collapseDownIcon"
                           [arrowButtonClass]="
                    isAssociationSelected
                        ? 'association-selected'
                        : 'association-unselected'
                "
                           [buttonClass]="
                    isAssociationSelected
                        ? 'association-selected'
                        : 'association-unselected'
                "
                           [disabled]="isDisabled || isAssociationDropdownDisabled"
                           (buttonClick)="onAssociationsClick()"
                           (itemClick)="onAssociationsItemClick($event)">
            <ng-template kendoSplitButtonItemTemplate let-dataItem>
                <span class="splitbutton-item"
                      [class.selected]="isSelected(dataItem)">
                    {{ dataItem.name }}
                </span>
            </ng-template>
        </kendo-splitbutton>
    </div>
    }

    <!-- NETWORK BUTTON -->
    @if (filterCollection.hasNetwork) {
    <span kendoTooltip
          position="top"
          [offset]="20"
          [title]="getFilterTooltip(filterCollection.network!)">
        <button class="btn btn-outline-primary"
                type="button"
                [class.active]="isSelected(filterCollection.network!)"
                [disabled]="
                    isDisabled || isFilterDisabled(filterCollection.network!)
                "
                (click)="onNetworkClick()">
            Network Data
        </button>
    </span>
    }

    <!-- DEBUG PANEL -->
    @if (showDebug()) {
    <div class="debug-panel">
        <strong>selectedFilters</strong>
        <pre>{{ selectedFilters | json }}</pre>
    </div>
    }
</div>
